// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { put, takeEvery } from 'redux-saga/effects'
import { TableDataCons } from '@/store/constant/table.constant'
import { getWorkgroup, addWorkgroup, getRoadMapList, getTechClassificationList, getProjectInfoList, getProjectInfoById } from '@/services/table.service'
import type {
    IClassification, IClassificationNoSub, IClassificationResData, IGetKeyRoadMapAction, IGetProjectInfoAction,
    IGetTechClassificationAction, IKeyRoadMap, IKeyRoadMapResData, IProjectInfo, IProjectInfoResData, IWorkgroup,
    IWorkgroupClassAddAction, IGetProjectInfoByIdAction
} from '@/store/models/tableEdit.model'
import {
    setWorkgroup, setKeyRoadMap, setKeyRoadMapPagination, setTechClassification, setProjectInfoList, setEdit2Data,
    setProjectInfoPagination, setClassificationPagination
} from '@/store/actions/tableEdit.action'
import { requestFail } from '@/store/actions/common.action'

export const getErrorStr = (error: string 
    | { message: string } 
    | { msg: string }): string => {
    sessionStorage.removeItem('requestMsg')
    let str = ''
    if (typeof error === 'string') {
        str = error
    } else if ('message' in error) {
        str = error.message
    } else {
        str = error.msg
    }
    return str
}

// 获取 workgroup 分类列表
function* handleGetWorkgroup(): unknown {
    try {
        const data: any[] = yield getWorkgroup()
        const workgroupList: IWorkgroup[] = data.map(item => ({
            id: item.id,
            groupName: item.workGroupName,
            ptnHeader: item.ptnHeader,
            loading: false
        }))
        yield put(setWorkgroup(workgroupList))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(requestFail(str))
    }
}
// 新增 workgroup 分类列表
function* handleAddWorkgroup(action: IWorkgroupClassAddAction): unknown {
    try {
        yield addWorkgroup(action.payload.groupName, action.payload.ptnHeader)
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(requestFail(str))
    }
}
// 获取KeyRoadMap 列表
function* handleGetKeyRoadMap(action: IGetKeyRoadMapAction): unknown {
    try {
        const { content, totalElements }: 
            {
                content: IKeyRoadMapResData[]
                totalElements: number
            } = yield getRoadMapList(action.payload)
        
        const keyRoadMapArr: IKeyRoadMap[] = content
            .filter(item => !item.parent)
            .map(item => ({
                id: item.id,
                version: item.version,
                parentId: item.parent ? item.parent.id : null,
                projectInfo: item.projectInfo || '',
                releaseStatus: item.releaseStatus,
                techName: item.techName,
                techPtn: item.techPtn,
                workGroupId: item.workGroup.id,
                phases: item.phases,
                year: item.year || 0,
                loading: false
            }))
        yield put(setKeyRoadMap(keyRoadMapArr))
        yield put(setKeyRoadMapPagination({
            total: totalElements
        }))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(requestFail(str))
        // yield put(setKeyRoadMap([]))
    }
}

function* handleGetClassification(action: IGetTechClassificationAction): unknown {
    try {
        const { content, totalElements }: 
            {
                content: IClassificationResData[]
                totalElements: number
            } = yield getTechClassificationList(action.payload)
        const classificationArr: (IClassification | IClassificationNoSub)[] = []
        content.forEach(item => {
            // 原为直接通过 techProjects 获取子级，现改为需要通过 techClassId 获取
            if (item.techProjects && item.techProjects.length) {
                classificationArr.push(...item.techProjects.map(subItem => ({
                    classId: item.id,
                    classificationName: item.classificationName,
                    workGroup: {
                        id: item.workGroup.id,
                        workGroupName: item.workGroup.workGroupName
                    },
                    id: subItem.id,
                    techPtn: subItem.techPtn,
                    researchForms: subItem.researchForms,
                    techName: subItem.techName,
                    subsidiary: subItem.subsidiary,
                    description: subItem.description,
                    keyTech: subItem.keyTech,
                    priority: subItem.priority,
                    quantitativeIndicators: subItem.quantitativeIndicators,
                    maturity: subItem.maturity,
                    requirementSource: subItem.requirementSource,
                    developedBy: subItem.developedBy,
                    buStakeholder: subItem.buStakeholder,
                    toolsEquipment: subItem.toolsEquipment,
                    resourceNeeded: subItem.resourceNeeded,
                    tmtapproval: subItem.tmtapproval,
                    techYearQuarters: subItem.techYearQuarters
                })))
            } else {
                classificationArr.push({
                    classId: item.id,
                    version: item.version,
                    classificationName: item.classificationName,
                    workGroup: {
                        id: item.workGroup.id,
                        workGroupName: item.workGroup.workGroupName
                    }
                })
            }
        })
        yield put(setTechClassification(classificationArr))
        // 设置分页参数
        yield put(setClassificationPagination({
            total: totalElements
        }))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(requestFail(str))
    }
}

function* handleGetTableData2(action: IGetProjectInfoAction): unknown {
    try {
        const { content, totalElements }: 
            {
                content: IProjectInfoResData[]
                totalElements: number
                pageable: {
                    offset: number
                    pageNumber: number
                    pageSize: number
                    paged: boolean
                    sort: {
                        empty: boolean
                        sorted: boolean
                        unsorted: boolean
                    }
                    unpaged: boolean
                }
            } = yield getProjectInfoList(action.payload)
        const projectInfoList = content.map(item => {
            const newItem: IProjectInfo = {
                ...item,
                techClassId: item.techClass.id,
                classificationName: item.techClass.classificationName
            }
            item.techYearQuarters.forEach(yearItem => {
                newItem[`${String(yearItem.year).substring(2)}-Q${yearItem.quarter}id`] = yearItem.id
                newItem[`${String(yearItem.year).substring(2)}-Q${yearItem.quarter}`] = yearItem.status
            })
            return newItem
        })
        yield put(setProjectInfoList(projectInfoList))
        // 设置分页参数
        yield put(setProjectInfoPagination({
            total: totalElements,
        }))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(requestFail(str))
    }
}

function* handleGetProjectInfo(action: IGetProjectInfoByIdAction): unknown {
    try {
        const res: IProjectInfoResData = yield getProjectInfoById(action.payload.projectInfoId)
        // 设置富文本默认值 导入的数据无格式问题
        let techName = '', description = '', quantitativeIndicators = ''
        if (res.techName && (res.techName.includes('"str":') && res.techName.includes('"obj":'))) {
            techName = res.techName
        } else {
            techName = res.techName
            techName = JSON.stringify({
                str: res.techName,
                obj: [{
                    type: 'paragraph',
                    children: [{ text: techName ? techName : '' }],
                }],
            })
        }
        if (res.description && (res.description.includes('"str":') && res.description.includes('"obj":'))) {
            description = res.description
        } else {
            description = res.description
            description = JSON.stringify({
                str: res.description,
                obj: [{
                    type: 'paragraph',
                    children: [{ text: description ? description : '' }],
                }],
            })
        }
        if (res.quantitativeIndicators && (res.quantitativeIndicators.includes('"str":') && res.quantitativeIndicators.includes('"obj":'))) {
            quantitativeIndicators = res.quantitativeIndicators
        } else {
            quantitativeIndicators = res.quantitativeIndicators
            quantitativeIndicators = JSON.stringify({
                str: res.quantitativeIndicators,
                obj: [{
                    type: 'paragraph',
                    children: [{ text: quantitativeIndicators ? quantitativeIndicators : '' }],
                }],
            })
        }
        const yearQuarterObj: Record<string, any> = {}
        res.techYearQuarters.forEach(yearItem => {
            yearQuarterObj[`${String(yearItem.year).substring(2)}-Q${yearItem.quarter}id`] = yearItem.id
            yearQuarterObj[`${String(yearItem.year).substring(2)}-Q${yearItem.quarter}`] = yearItem.status
        })
        yield put(setEdit2Data({
            ...yearQuarterObj,
            id: res.id,
            version: res.version,
            buStakeholder: res.buStakeholder,
            description,
            developedBy: res.developedBy,
            techLevel: res.techLevel,
            maturity: res.maturity,
            priority: res.priority,
            quantitativeIndicators,
            requirementSource: res.requirementSource,
            researchForms: res.researchForms,
            resourceNeeded: res.resourceNeeded,
            subsidiary: res.subsidiary,
            techClassId: res.techClass.id,
            classificationName: res.techClass.classificationName,
            techName,
            techPtn: res.techPtn,
            tmtapproval: res.tmtapproval,
            toolsEquipment: res.toolsEquipment,
            techYearQuarters: res.techYearQuarters,
            relevanceBuss: res.relevanceBuss,
            isMajorProject: res.isMajorProject,
            planBudgeting: res.planBudgeting,
            humanBudgeting: res.humanBudgeting,
            budgeting: res.budgeting,
            dutyBuss: res.dutyBuss,
            platforms: res.platforms,
            almCode: res?.almCode,
            deliveryReview: res?.deliveryReview,
            projectId: res?.project?.id,
            projectNo: res?.project?.projectNo,
            projectName: res?.project?.projectName,
            approvalDate: res?.project?.approvalDate,
            estimateClosedDate: res?.project?.estimateClosedDate,
            actualClosedDate: res?.project?.actualClosedDate,
            projectResult: res?.project?.projectResult,
            techMaturity: res?.techMaturity,
            patentId: res?.parent?.id,
            patentCode: res?.patent?.patentCode,
            patentNum: res?.patent?.patentNum,
            patentStatus: res?.patent?.patentStatus
        }))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(requestFail(str))
    }
}

export default function* authSaga(): unknown {
    // 获取 workgroup 分类列表
    yield takeEvery(TableDataCons.GETWORKGROUPCLASS, handleGetWorkgroup)
    // 新增 workgroup 分类列表
    yield takeEvery(TableDataCons.ADDWORKGROUPCLASS, handleAddWorkgroup)
    // 编辑 workgroup 分类列表
    // yield takeEvery(TableDataCons.EDITWORKGROUPCLASS, handleEditWorkgroup)
    // 删除 workgroup 分类列表
    // yield takeEvery(TableDataCons.DELWORKGROUPCLASS, handleDelWorkgroup)
    // 获取 keyroadmap 表格列表
    yield takeEvery(TableDataCons.GETKEYROADMAP, handleGetKeyRoadMap)
    // 获取 classification 分类列表
    yield takeEvery(TableDataCons.GETTECHCLASSIFICATION, handleGetClassification)
    // 获取 techProjectInfo 表格列表
    yield takeEvery(TableDataCons.GETPROJECTINFO, handleGetTableData2)
    // 通过 id 获取 techProjectInfo
    yield takeEvery(TableDataCons.GETPROJECTINFOBYID, handleGetProjectInfo)
}
